<template>
  <BaseSelector
    class="distanceSelector"
    :title="title"
    :options="options"
    :selectValue="selectValue"
    @selectChangeHandler="selectChangeHandler"
  ></BaseSelector>
</template>

<script>
import BaseSelector from '@/components/common/select/BaseSelector'

export default {
  props: {
    selectValue: {
      type: Number,
    },
  },
  data() {
    return {
      title: '公里數:',
      options: [
        { value: 5000, description: '5公里' },
        { value: 8000, description: '8公里' },
        { value: 10000, description: '10公里' },
        { value: 99999, description: '強制' },
      ],
    }
  },
  methods: {
    selectChangeHandler(value) {
      this.$emit('selectChangeHandler', value)
    },
  },
  components: {
    BaseSelector,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/select/DistanceSelector.vue